import { camelCase } from '@0x234/common-util/string';
import { boot } from 'quasar/wrappers';

export default boot(async ({ store }) => {
    const initialState = process.env.CLIENT ? window.__INITIAL_STATE__ : null;
    if (!initialState) {
        return;
    }
    for (const storeName of Object.keys(initialState)) {
        // As stores are loaded dynamically, it needs to be loaded in order to get the initial state and to compare the
        // data types. It will only load the stores which are included in the initial state, if necessary.
        const actualStateRef = store.state.value[storeName] ?? await initStore(storeName);
        const storeInitialState = initialState[storeName];
        const storePreventHydrate = store._s.get(storeName)?.preventHydrate || [];
        if (!storeInitialState || !actualStateRef) {
            continue;
        }
        Object.keys(storeInitialState).forEach(stateProp => {
            if (storePreventHydrate.includes(stateProp)) {
                return;
            }
            const actualValue = actualStateRef[stateProp];
            const initialValue = storeInitialState[stateProp];
            if (actualValue instanceof Map) {
                actualStateRef[stateProp] = new Map(Object.entries(initialValue));
                return;
            }
            if (actualValue instanceof Set) {
                actualStateRef[stateProp] = new Set(initialValue);
                return;
            }
            actualStateRef[stateProp] = initialValue;
        });
    }
});

async function initStore(storeName) {
    try {
        const functionName = camelCase(`use-${storeName}-store`);
        const module = await import(`../stores/${storeName}-store.js`);
        const useStore = module[functionName];
        return useStore()?.$state;
    }
    catch (err) {
        console.error(`Error importing ${storeName}:`, err);
    }
    return null;
}
